// extracted by mini-css-extract-plugin
module.exports = {"campoPesquisa":"ParametrosConsulta_campoPesquisa__2PUa3","botao":"ParametrosConsulta_botao__2gLGg","icone":"ParametrosConsulta_icone__faCoZ"};